import SimpleBar from 'simplebar'
import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'simplebar',

  componentDidMount () {
    /* eslint-disable-next-line */
    new SimpleBar(this.el)
  },
})
